import { getMarket } from '../i18n';
import { phonenumbers } from '../utils';

export const parsePhoneNumber = (raw: any) => {
  let result: {
    e164?: string;
    national?: string;
    international?: string;
  } = {};

  try {
    const { marketCode } = getMarket();
    const phoneNumber = phonenumbers.parse(raw, marketCode);

    if (phoneNumber?.isValid()) {
      return {
        e164: phoneNumber.getURI(),
        national: phoneNumber.formatNational(),
        international: phoneNumber.formatInternational(),
      };
    }
  } catch (_e) {
    result = {};
  }

  return result;
};
